import RoomLayout from "/components/shared/layouts/RoomLayout";
import RoomBox from "/components/shared/layouts/RoomBox";
import ViewHeader from "/components/shared/ViewHeader.jsx";
import SubViewHeader from "/components/shared/SubViewHeader";
import {useContext, useEffect, useState} from "react";
import FilterEventContext from "/context/filter/FilterContext";
import Head from "next/head";
import { sortBy } from "lodash";
import Cards from "/components/shared/card/Cards";
import AppContext from "/context/AppContext";
import {fetchProductions} from '/api/productions';
import {filterProductions} from '/utils';
import {SvgCalendarGrid} from '/components/shared/SvgIcons'

export default function Productions() {
    const {productions} = useContext(AppContext);
    const [filteredProductions, setFilteredProductions] = useState(productions);
    const {state: {searchQuery}} = useContext(FilterEventContext);

    useEffect(() => {
        setFilteredProductions(filterProductions(productions, searchQuery));
    }, [searchQuery]);


    const sortedProductions = sortBy(filteredProductions, 'age_restriction');

    return (
        <RoomLayout key="room" background="bg-cover bg-foyerBlurred">
          <RoomBox style='mt-24'>
            <div className="bg-light_brown md:px-8 py-2 md:py-8 rounded-t-[16px]">
              <ViewHeader title="zum foyer" url="/foyer"/>
              <SubViewHeader
                url="/schedule"
                label="Alle Stücke"
                icon={<div className="mr-3 pb-1">{SvgCalendarGrid('#fff')}</div>}
                buttonLabel="Zum Spielplan"
              />
            </div>
            <Cards productions={sortedProductions}/>
          </RoomBox>
        </RoomLayout>
    );
}

export async function getStaticProps(context) {
    const productions = await fetchProductions();
    return {
        props: {
            productions
        },
        revalidate: 60
    };
}

